<template>
    <RouterView />
</template>

<script setup>
const store = useStore()

watch(() => store.state.settings.mode, () => {
    if (store.state.settings.mode === 'pc') {
        store.commit('settings/updateThemeSetting', {
            'sidebarCollapse': store.state.settings.sidebarCollapseLastStatus
        })
    } else if (store.state.settings.mode === 'mobile') {
        store.commit('settings/updateThemeSetting', {
            'sidebarCollapse': true
        })
    }
    document.body.setAttribute('data-mode', store.state.settings.mode)
}, {
    immediate: true
})

watch([
    () => store.state.settings.menuMode,
    () => store.state.settings.sidebarCollapse
], () => setMenuMode(), {
    immediate: true
})

function setMenuMode() {
    document.body.removeAttribute('data-sidebar-no-collapse')
    document.body.removeAttribute('data-sidebar-collapse')
    if (store.state.settings.sidebarCollapse) {
        document.body.setAttribute('data-sidebar-collapse', '')
    } else {
        document.body.setAttribute('data-sidebar-no-collapse', '')
    }
    document.body.setAttribute('data-menu-mode', store.state.settings.menuMode)
}

watch([
    () => store.state.settings.enableDynamicTitle,
    () => store.state.settings.title
], () => setDocumentTitle(), {
    immediate: true
})

function setDocumentTitle() {
    if (store.state.settings.enableDynamicTitle && store.state.settings.title) {
        let title = store.state.settings.title
        document.title = `${title} - ${import.meta.env.VITE_APP_TITLE}`
        // document.title = title
    } else {
        // document.title = import.meta.env.VITE_APP_TITLE
    }
}

onMounted(() => {
    window.onresize = () => {
        // store.commit('settings/setMode', document.documentElement.clientWidth)
        store.commit('settings/setMode', 1280)
        if (document.documentElement.clientWidth < 1470) {
            store.commit('settings/updateThemeSetting', {
                'sidebarCollapse': true
            })
        } else {
            store.commit('settings/updateThemeSetting', {
                'sidebarCollapse': false
            })
        }
    }
    window.onresize()

    // if (store.getters['user/isLogin']) {
    //     store.dispatch('user/getUserInfo', 1)
    // }
})
</script>
